import Table from "../../../../contents/_includes/example-table.mdx";
import * as React from 'react';
export default {
  Table,
  React
};